import { render, staticRenderFns } from "./yongComponent.vue?vue&type=template&id=f6c192bc&scoped=true"
import script from "./yongComponent.vue?vue&type=script&lang=js"
export * from "./yongComponent.vue?vue&type=script&lang=js"
import style0 from "./yongComponent.vue?vue&type=style&index=0&id=f6c192bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c192bc",
  null
  
)

export default component.exports